import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSections = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.265 9.125C2.6075 9.125 1.265 10.4675 1.265 12.125C1.265 13.7825 2.6075 15.125 4.265 15.125C5.9225 15.125 7.265 13.7825 7.265 12.125C7.265 10.4675 5.9225 9.125 4.265 9.125ZM4.265 13.625C3.44 13.625 2.765 12.95 2.765 12.125C2.765 11.3 3.44 10.625 4.265 10.625C5.09 10.625 5.765 11.3 5.765 12.125C5.765 12.95 5.09 13.625 4.265 13.625ZM8.75 9.125V15.125H14.75V9.125H8.75ZM13.25 13.625H10.25V10.625H13.25V13.625ZM4.25 0.875L0.5 7.625H8L4.25 0.875ZM4.25 3.965L5.45 6.125H3.05L4.25 3.965ZM13.4375 1.25C12.6425 1.25 12.08 1.67 11.75 2.1275C11.42 1.67 10.8575 1.25 10.0625 1.25C8.8925 1.25 8 2.21 8 3.3125C8 4.8125 9.815 5.8775 11.75 7.625C13.685 5.8775 15.5 4.8125 15.5 3.3125C15.5 2.21 14.6075 1.25 13.4375 1.25ZM11.75 5.6375C10.6625 4.7225 9.5 3.8375 9.5 3.3125C9.5 2.99 9.7625 2.75 10.0625 2.75C10.295 2.75 10.4525 2.8775 10.61 3.0275L11.75 4.1L12.89 3.0275C13.0475 2.8775 13.205 2.75 13.4375 2.75C13.7375 2.75 14 2.99 14 3.3125C14 3.8375 12.8375 4.7225 11.75 5.6375Z",
		fill: "white"
	})
});
export default SvgSections;
